<template>
  <div class="order-item mb-2">
    <div class="order-inner-item">
      <h3 class="order-title">{{orderitem.title}}</h3>
      <div class="order-detail-item" v-html="orderitem.des"></div>
      <div class="final-price mt-4">
        مجموع قیمت:   {{orderitem.price | toPersianCurrency("تومان",0)}}
      </div>

      <p>زمان خرید:  {{orderitem.p_date}}</p>

      <p class="mt-3" :style="`color: ${getColor(orderitem.status_code)}`">وضعیت:  {{orderitem.status}}</p>

      <a v-if="orderitem.status_code !== '2'" class="btn pdfdownload d-flex align-items-center justify-content-center" @click="orderitem.tickets_pdf === null ? preventDefault() : null" :href="`${orderitem.tickets_pdf ? orderitem.tickets_pdf : '#'}`" :style="`background : ${getPdfbackgroundColor(orderitem.tickets_pdf)}`">{{orderitem.tickets_pdf ? "دانلود بلیط" : "... در انتظار صدور بلیط "}}</a>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  props:{
    orderitem: {}
  },

  computed: {

  },
  methods: {
    getColor(status){
      switch (status){
        case "1":
          return "#00d000";
          break;
        case "2":
          return "rgb(255 30 30)";
          break;
        case "3":
          return "#00d000";
          break;
        default:
          return "#00d000"
          break;
      }
    },
    getPdfbackgroundColor(value){
      if(value){
        return "#8bc34a";
      }
    }

  },
};
</script>

<style lang="scss" scoped>
  .order-item {
    background: #424242ad;
    border-radius: 8px;
    text-align: right;
    color: #ffff;
    padding: 18px;
    .pdfdownload {
      background: #BBBBBB;
      width: 100%;
      height: 42px;
      color: #ffffff;
    }
  }

</style>
